<div class="adventures-page-container">
  <div class="adventures-status" *ngIf="loading || loadError || !cards.length" [attr.aria-busy]="loading">
    <h1>
      <app-texts [texts]="[{text: ['Идеи для путешествий', 'Adventures']}]"/>
    </h1>
    <p *ngIf="loading" role="status">
      <app-texts
        [texts]="[{text: ['Подбираем идеи для вашего путешествия…', 'Finding inspiration for your next journey…']}]"/>
    </p>
    <div class="adventures-skeleton" *ngIf="loading" aria-hidden="true">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <p *ngIf="loadError" role="alert">
      <app-texts
        [texts]="[{text: ['Не удалось загрузить путешествия. Попробуйте ещё раз.', 'Unable to load adventures. Please try again.']}]"/>
    </p>
    <p *ngIf="!loading && !loadError && !cards.length">
      <app-texts
        [texts]="[{text: ['Новые идеи для путешествий скоро появятся.', 'New adventures are coming soon.']}]"/>
    </p>
    <button type="button" *ngIf="loadError" (click)="loadAdventures()">
      <app-texts
        [texts]="[{text: ['Повторить', 'Try again']}]"/>
    </button>
  </div>
  <app-section *ngIf="!loading && !loadError && cards.length">
    <app-main-best-hotels [title]="false" [subtitle]="true" [subtitleText]="['Идеи для путешествий', 'Adventures']"
                          [cards]="cards" [paddingLess]="true"/>
  </app-section>
  <!--  <app-section class="adventure-circle-section-container">-->
  <!--    <app-running-line/>-->
  <!--    <app-section-scroller>-->
  <!--      <app-main-destinations (ClickOnActive)="goToDestination($event)"/>-->
  <!--    </app-section-scroller>-->
  <!--  </app-section>-->
</div>
